import { createSlice } from "@reduxjs/toolkit"
import {
  getAllSalesReports,
  getAllB2CSalesReports,
  getAllB2CSummarySalesReports,
  getBusinessTaxReports,
  getLoyaltyPointsReports,
  getPaymentMethodReports,
  getGiftcardReports,
  getPremiumGiftcardReports,
  getWalletdReports,
  getWalletTransferReports,
  getWalletPurchaseReports,
} from "store/actions/reportsAction"

const initialState = {
  loading: true,
  isLoading: false,
  itemsPerPage: 10,
  totalPages: null,
  totalCount: null,
  currentPage: 1,
  salesReports: [],
  b2cSalesReports: [],
  b2cSummarySalesReports: [],
  paymentsMethodReports: [],
  businessTaxReports: [],
  loyaltyPointsReports: [],
  giftcardReports: [],
  premiumGiftcardReports: [],
  walletReport: [],
  walletTransferReport: [],
  walletPurchaseReport: [],
}

const usersSlice = createSlice({
  name: "countries",
  initialState,
  reducers: {},
  extraReducers: builder => {
    // GET ALL SALES REPORTS
    builder
      .addCase(getAllSalesReports.pending, state => {
        state.loading = true
        state.totalCount = null
        state.totalPages = null
        state.currentPage = null
      })
      .addCase(getAllSalesReports.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.salesReports = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getAllSalesReports.rejected, (state, action) => {
        state.loading = false
      })

      // GET ALL B2C SALES REPORTS
      .addCase(getAllB2CSalesReports.pending, state => {
        state.loading = true
        state.totalCount = null
        state.totalPages = null
        state.currentPage = null
      })
      .addCase(getAllB2CSalesReports.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.b2cSalesReports = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getAllB2CSalesReports.rejected, (state, action) => {
        state.loading = false
      })
      // GET ALL B2C SUMMARY SALES REPORTS
      .addCase(getAllB2CSummarySalesReports.pending, state => {
        state.loading = true
        state.totalCount = null
        state.totalPages = null
        state.currentPage = null
      })
      .addCase(getAllB2CSummarySalesReports.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.b2cSummarySalesReports = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getAllB2CSummarySalesReports.rejected, (state, action) => {
        state.loading = false
      })

    // GET GIFT CARD REPORTS
    builder
      .addCase(getGiftcardReports.pending, state => {
        state.loading = true
        state.totalCount = null
        state.totalPages = null
        state.currentPage = null
      })
      .addCase(getGiftcardReports.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.giftcardReports = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })

      .addCase(getGiftcardReports.rejected, (state, action) => {
        state.loading = false
      })

    // GET PREMIUM GIFT CARD REPORTS
    builder
      .addCase(getPremiumGiftcardReports.pending, state => {
        state.loading = true
        state.totalCount = null
        state.totalPages = null
        state.currentPage = null
      })
      .addCase(getPremiumGiftcardReports.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.premiumGiftcardReports = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getPremiumGiftcardReports.rejected, (state, action) => {
        state.loading = false
      })

    // WALLET REPORT
    builder
      .addCase(getWalletdReports.pending, state => {
        state.loading = true
        state.totalCount = null
        state.totalPages = null
        state.currentPage = null
      })
      .addCase(getWalletdReports.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.walletReport = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })

      .addCase(getWalletdReports.rejected, (state, action) => {
        state.loading = false
      })

    // WALLET TRANSFER REPORT
    builder
      .addCase(getWalletTransferReports.pending, state => {
        state.loading = true
        state.totalCount = null
        state.totalPages = null
        state.currentPage = null
      })
      .addCase(getWalletTransferReports.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.walletTransferReport = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })

      .addCase(getWalletTransferReports.rejected, (state, action) => {
        state.loading = false
      })
    // WALLET PURCHASE REPORT
    builder
      .addCase(getWalletPurchaseReports.pending, state => {
        state.loading = true
        state.totalCount = null
        state.totalPages = null
        state.currentPage = null
      })
      .addCase(getWalletPurchaseReports.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.walletPurchaseReport = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getWalletPurchaseReports.rejected, (state, action) => {
        state.loading = false
      })
    // GET PAYMENTS METHOD REPORTS
    builder
      .addCase(getPaymentMethodReports.pending, state => {
        state.loading = true
        state.totalCount = null
        state.totalPages = null
        state.currentPage = null
      })
      .addCase(getPaymentMethodReports.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.paymentsMethodReports = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getPaymentMethodReports.rejected, (state, action) => {
        state.loading = false
      })

    // GET BUSINESS TAX REPORTS
    builder
      .addCase(getBusinessTaxReports.pending, state => {
        state.loading = true
        state.totalCount = null
        state.totalPages = null
        state.currentPage = null
      })
      .addCase(getBusinessTaxReports.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.businessTaxReports = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getBusinessTaxReports.rejected, (state, action) => {
        state.loading = false
      })

    // GET LOYALTY POINTS REPORTS
    builder
      .addCase(getLoyaltyPointsReports.pending, state => {
        state.loading = true
        state.totalCount = null
        state.totalPages = null
        state.currentPage = null
        state.loyaltyPointsReports = []
      })
      .addCase(getLoyaltyPointsReports.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.loyaltyPointsReports = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getLoyaltyPointsReports.rejected, (state, action) => {
        state.loading = false
      })
  },
})

export default usersSlice.reducer
